"use strict";
const { v4: uuid } = require('uuid');
const { generateStringConstant, generateArrayOfStringConstant, generateNumberConstant, generateNumberBetweenConstant, generateDateConstant, generateDateRangeConstant, generateDateBetweenConstant, } = require('./constantFactory');
const { OR, AND, EQUALS, CONTAINS, STARTS_WITH, ENDS_WITH, GREATER_THAN, LESS_THAN, AFTER, BEFORE, BETWEEN, IN_THE_NEXT, HAS_PASSED, ARRAY_CONTAINS, } = require('../operators');
const { EXPRESSION } = require('../conditionType');
exports.generateExpression = ({ id = uuid(), operator, right, left, operands, }) => {
    const expression = {
        id,
        type: EXPRESSION,
        operator,
        right,
        left,
        operands,
    };
    /** right/left are only used by comparison operators (ie. EQUALS, STARTS_WITH).
     *  operands are only used by OR/AND operators.
     *  We can safely delete them if they are undefined.
     */
    Object.keys(expression).forEach((key) => expression[key] === undefined && delete expression[key]);
    return expression;
};
exports.generateAndExpression = ({ operands }) => exports.generateExpression({
    operator: AND,
    operands,
});
exports.generateOrExpression = ({ operands }) => exports.generateExpression({
    operator: OR,
    operands,
});
exports.generateStringConstantExpression = ({ operator, leftValue, rightValue, }) => exports.generateExpression({
    operator,
    left: generateStringConstant({ value: leftValue }),
    right: generateStringConstant({ value: rightValue }),
});
// Is this factory method acceptable?
// Does it really matter if it's an (array of string) or an (array of number)?
exports.generateArrayOfStringConstantExpression = ({ operator, leftValue, rightValue, }) => exports.generateExpression({
    operator,
    left: generateArrayOfStringConstant({ value: leftValue }),
    right: generateStringConstant({ value: rightValue }),
});
exports.generateNumberConstantExpression = ({ operator, leftValue, rightValue, }) => exports.generateExpression({
    operator,
    left: generateNumberConstant({ value: leftValue }),
    right: generateNumberConstant({ value: rightValue }),
});
exports.generateDateConstantExpression = ({ operator, leftValue, rightValue, }) => exports.generateExpression({
    operator,
    left: generateDateConstant({ value: leftValue }),
    right: generateDateConstant({ value: rightValue }),
});
exports.generateDateBetweenExpression = ({ leftValue, afterValue, beforeValue, }) => exports.generateExpression({
    operator: BETWEEN,
    left: generateDateConstant({ value: leftValue }),
    right: generateDateBetweenConstant({ afterValue, beforeValue }),
});
exports.generateNumberBetweenExpression = ({ leftValue, greaterThanValue, lessThanValue, }) => exports.generateExpression({
    operator: BETWEEN,
    left: generateNumberConstant({ value: leftValue }),
    right: generateNumberBetweenConstant({ greaterThanValue, lessThanValue }),
});
exports.generateNumberGreaterThanExpression = ({ leftValue, rightValue }) => exports.generateNumberConstantExpression({
    operator: GREATER_THAN,
    leftValue,
    rightValue,
});
exports.generateNumberLessThanExpression = ({ leftValue, rightValue }) => exports.generateNumberConstantExpression({
    operator: LESS_THAN,
    leftValue,
    rightValue,
});
exports.generateDateAfterExpression = ({ leftValue, afterValue }) => exports.generateDateConstantExpression({
    operator: AFTER,
    leftValue,
    rightValue: afterValue,
});
exports.generateDateBeforeExpression = ({ leftValue, beforeValue }) => exports.generateDateConstantExpression({
    operator: BEFORE,
    leftValue,
    rightValue: beforeValue,
});
exports.generateDateInTheNextExpression = ({ leftValue, durationValue, durationUnit, }) => exports.generateExpression({
    operator: IN_THE_NEXT,
    left: generateDateConstant({ value: leftValue }),
    right: generateDateRangeConstant({
        durationValue,
        durationUnit,
    }),
});
exports.generateDateHasPassedExpression = ({ leftValue, durationValue, durationUnit, }) => exports.generateExpression({
    operator: HAS_PASSED,
    left: generateDateConstant({ value: leftValue }),
    right: generateDateRangeConstant({
        durationValue,
        durationUnit,
    }),
});
exports.generateStringEqualsExpression = ({ leftValue, rightValue }) => exports.generateStringConstantExpression({
    operator: EQUALS,
    leftValue,
    rightValue,
});
exports.generateDateEqualsExpression = ({ leftValue, rightValue }) => exports.generateDateConstantExpression({
    operator: EQUALS,
    leftValue,
    rightValue,
});
exports.generateStringContainsExpression = ({ leftValue, rightValue }) => exports.generateStringConstantExpression({
    operator: CONTAINS,
    leftValue,
    rightValue,
});
exports.generateStringStartsWithExpression = ({ leftValue, rightValue }) => exports.generateStringConstantExpression({
    operator: STARTS_WITH,
    leftValue,
    rightValue,
});
exports.generateStringEndsWithExpression = ({ leftValue, rightValue }) => exports.generateStringConstantExpression({
    operator: ENDS_WITH,
    leftValue,
    rightValue,
});
exports.generateArrayContainsExpression = ({ leftValue, rightValue }) => exports.generateArrayOfStringConstantExpression({
    operator: ARRAY_CONTAINS,
    leftValue,
    rightValue,
});
//# sourceMappingURL=expressionFactory.js.map